// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TextField Component Styles */

.scl--web-component-text-field-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  padding-bottom: 20px;
  width: 100%;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  caret-color: transparent;
  position: relative;
}

.scl--web-component-text-field-input-plate {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  height: 52px;
  border: 1px solid #7D8187;
  border-radius: 2px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  transition: border-color 0.3s ease;
  position: relative;
  cursor: text;
}

.scl--web-component-text-field-input-plate::after {
  content: '';
  position: absolute;
  left: -1px;
  bottom: -1px;
  width: calc(100% + 2px);
  height: 4px;
  background: #84A578;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.scl--web-component-text-field-input-plate:focus-within::after {
  opacity: 1;
}

.scl--web-component-text-field-input-plate:hover:not(:focus-within) {
  border-color: #9EA0A4;
}

.scl--web-component-text-field-input-plate:focus-within {
  border-color: #9EA0A4;
}

.scl--web-component-text-field-input-plate.warning::after {
  background: #FFC18E;
  opacity: 1;
}

.scl--web-component-text-field-input-plate.error::after {
  background: #F8868A;
  opacity: 1;
}

.scl--web-component-text-field-input-plate.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.scl--web-component-text-field-input-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 13px 0px 20px;
  gap: 12px;
  width: 100%;
  height: 52px;
  flex: 1;
  order: 0;
  flex-grow: 1;
  box-sizing: border-box;
}

.scl--web-component-text-field-start-adornment {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1px 0px 3px;
  width: 20px;
  height: 24px;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.scl--web-component-text-field-value-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  height: 100%;
  flex: 1;
  order: 1;
  flex-grow: 1;
}

.scl--web-component-text-field-text-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0px;
  width: 100%;
  height: 100%;
  flex: 1;
  order: 0;
  flex-grow: 1;
  position: relative;
}

.scl--web-component-text-field-input {
  width: 100%;
  height: 80%;
  font-family: var(--primary-font);
  font-style: light;
  font-weight: 274;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: 0.50px;
  color: #FFFFFF;
  background: transparent;
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  flex: 1;
  order: 1;
  flex-grow: 1;
  caret-color: transparent !important;
}

.scl--web-component-text-field-input:focus {
  caret-color: #FFFFFF !important;
}

.scl--web-component-text-field-input:disabled {
  cursor: not-allowed;
}

/* Disable autofill styles */
.scl--web-component-text-field-input:-webkit-autofill,
.scl--web-component-text-field-input:-webkit-autofill:hover,
.scl--web-component-text-field-input:-webkit-autofill:focus,
.scl--web-component-text-field-input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #0A0A0A inset !important;
  -webkit-text-fill-color: #FFFFFF !important;
  transition: background-color 5000s ease-in-out 0s;
}

.scl--web-component-text-field-end-adornment {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 1px 0px;
  width: 24px;
  height: 26px;
  flex: none;
  order: 2;
  flex-grow: 0;
}

.scl--web-component-text-field-assistive {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 4px 2px 14px;
  height: 16px;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: -0.15px;
  color: rgba(255, 255, 255, 0.54);
}

.scl--web-component-text-field-assistive.error {
  color: #FF5252;
}

/* ✅ Floating Label Styles - Always visible, animates position */
.scl--web-component-text-field-label {
  position: absolute;
  left: 21px;
  top: 50%;
  transform: translateY(-50%);
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #7D8187;
  background: transparent;
  padding: 0 4px;
  margin: 0 -4px;
  pointer-events: none;
  transition: all 0.3s ease;
  z-index: 1;
  opacity: 1;
}

/* ✅ Floating state - label moves to top */
.scl--web-component-text-field-label.floating {
  top: 0;
  transform: translateY(-50%);
  font-size: 14px;
  line-height: 16px;
  background: #0A0A0A;
  color: #7D8187;
  padding: 0 6px;
  margin: 0 -6px;
}

.scl--web-component-text-field-input-plate:focus-within .scl--web-component-text-field-label {
  top: 0;
  transform: translateY(-50%);
  font-size: 14px;
  line-height: 16px;
  background: #0A0A0A;
  color: #7D8187;
  padding: 0 6px;
  margin: 0 -6px;
}

/* ✅ Hover effect on label when field is not focused */
.scl--web-component-text-field-input-plate:hover:not(:focus-within) .scl--web-component-text-field-label {
  color: #C9CACD;
}

.scl--web-component-text-field-input-plate:hover:not(:focus-within) .scl--web-component-text-field-label .scl--web-component-text-field-required-asterisk {
  color: #EB5252;
}

/* Clear Button Styles */
.scl--web-component-text-field-clear-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  margin: 14px 0 0 0;
  background: transparent;
  border: none;
  cursor: pointer;
  flex: none;
  order: 1;
  flex-grow: 0;
  color: #7D8187;
  align-self: flex-start;
  opacity: 1;
  transform: scale(1);
  transition: all 0.3s ease;
  pointer-events: auto;
}

.scl--web-component-text-field-clear-button:hover {
  color: #FFFFFF;
}

.scl--web-component-text-field-clear-button.hidden {
  opacity: 0;
  transform: scale(0.8);
  pointer-events: none;
}

/* Required Asterisk Styles */
.scl--web-component-text-field-required-asterisk {
  color: #EB5252;
}`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/input/text-field/css/textField.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,SAAS;EACT,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;;;;EAIE,uDAAuD;EACvD,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,UAAU;EACV,UAAU;AACZ;;AAEA,0CAA0C;AAC1C;EACE,MAAM;EACN,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,MAAM;EACN,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;AAChB","sourcesContent":["/* TextField Component Styles */\n\n.scl--web-component-text-field-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  padding-bottom: 20px;\n  width: 100%;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  caret-color: transparent;\n  position: relative;\n}\n\n.scl--web-component-text-field-input-plate {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n  height: 52px;\n  border: 1px solid #7D8187;\n  border-radius: 2px;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  transition: border-color 0.3s ease;\n  position: relative;\n  cursor: text;\n}\n\n.scl--web-component-text-field-input-plate::after {\n  content: '';\n  position: absolute;\n  left: -1px;\n  bottom: -1px;\n  width: calc(100% + 2px);\n  height: 4px;\n  background: #84A578;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.scl--web-component-text-field-input-plate:focus-within::after {\n  opacity: 1;\n}\n\n.scl--web-component-text-field-input-plate:hover:not(:focus-within) {\n  border-color: #9EA0A4;\n}\n\n.scl--web-component-text-field-input-plate:focus-within {\n  border-color: #9EA0A4;\n}\n\n.scl--web-component-text-field-input-plate.warning::after {\n  background: #FFC18E;\n  opacity: 1;\n}\n\n.scl--web-component-text-field-input-plate.error::after {\n  background: #F8868A;\n  opacity: 1;\n}\n\n.scl--web-component-text-field-input-plate.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.scl--web-component-text-field-input-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px 13px 0px 20px;\n  gap: 12px;\n  width: 100%;\n  height: 52px;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n  box-sizing: border-box;\n}\n\n.scl--web-component-text-field-start-adornment {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 1px 0px 3px;\n  width: 20px;\n  height: 24px;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.scl--web-component-text-field-value-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0;\n  height: 100%;\n  flex: 1;\n  order: 1;\n  flex-grow: 1;\n}\n\n.scl--web-component-text-field-text-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 0px;\n  width: 100%;\n  height: 100%;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n  position: relative;\n}\n\n.scl--web-component-text-field-input {\n  width: 100%;\n  height: 80%;\n  font-family: var(--primary-font);\n  font-style: light;\n  font-weight: 274;\n  font-size: 18px;\n  line-height: 20px;\n  letter-spacing: 0.50px;\n  color: #FFFFFF;\n  background: transparent;\n  border: none;\n  outline: none;\n  padding: 0;\n  margin: 0;\n  flex: 1;\n  order: 1;\n  flex-grow: 1;\n  caret-color: transparent !important;\n}\n\n.scl--web-component-text-field-input:focus {\n  caret-color: #FFFFFF !important;\n}\n\n.scl--web-component-text-field-input:disabled {\n  cursor: not-allowed;\n}\n\n/* Disable autofill styles */\n.scl--web-component-text-field-input:-webkit-autofill,\n.scl--web-component-text-field-input:-webkit-autofill:hover,\n.scl--web-component-text-field-input:-webkit-autofill:focus,\n.scl--web-component-text-field-input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px #0A0A0A inset !important;\n  -webkit-text-fill-color: #FFFFFF !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n.scl--web-component-text-field-end-adornment {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 1px 0px;\n  width: 24px;\n  height: 26px;\n  flex: none;\n  order: 2;\n  flex-grow: 0;\n}\n\n.scl--web-component-text-field-assistive {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 2px 4px 2px 14px;\n  height: 16px;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: -0.15px;\n  color: rgba(255, 255, 255, 0.54);\n}\n\n.scl--web-component-text-field-assistive.error {\n  color: #FF5252;\n}\n\n/* ✅ Floating Label Styles - Always visible, animates position */\n.scl--web-component-text-field-label {\n  position: absolute;\n  left: 21px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 18px;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  color: #7D8187;\n  background: transparent;\n  padding: 0 4px;\n  margin: 0 -4px;\n  pointer-events: none;\n  transition: all 0.3s ease;\n  z-index: 1;\n  opacity: 1;\n}\n\n/* ✅ Floating state - label moves to top */\n.scl--web-component-text-field-label.floating {\n  top: 0;\n  transform: translateY(-50%);\n  font-size: 14px;\n  line-height: 16px;\n  background: #0A0A0A;\n  color: #7D8187;\n  padding: 0 6px;\n  margin: 0 -6px;\n}\n\n.scl--web-component-text-field-input-plate:focus-within .scl--web-component-text-field-label {\n  top: 0;\n  transform: translateY(-50%);\n  font-size: 14px;\n  line-height: 16px;\n  background: #0A0A0A;\n  color: #7D8187;\n  padding: 0 6px;\n  margin: 0 -6px;\n}\n\n/* ✅ Hover effect on label when field is not focused */\n.scl--web-component-text-field-input-plate:hover:not(:focus-within) .scl--web-component-text-field-label {\n  color: #C9CACD;\n}\n\n.scl--web-component-text-field-input-plate:hover:not(:focus-within) .scl--web-component-text-field-label .scl--web-component-text-field-required-asterisk {\n  color: #EB5252;\n}\n\n/* Clear Button Styles */\n.scl--web-component-text-field-clear-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  margin: 14px 0 0 0;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n  color: #7D8187;\n  align-self: flex-start;\n  opacity: 1;\n  transform: scale(1);\n  transition: all 0.3s ease;\n  pointer-events: auto;\n}\n\n.scl--web-component-text-field-clear-button:hover {\n  color: #FFFFFF;\n}\n\n.scl--web-component-text-field-clear-button.hidden {\n  opacity: 0;\n  transform: scale(0.8);\n  pointer-events: none;\n}\n\n/* Required Asterisk Styles */\n.scl--web-component-text-field-required-asterisk {\n  color: #EB5252;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
